/* ==========================================================================
   "Maak het compleet" - upsell-blok onder de koopknop
   Markup:  snippets/upsell-compleet.liquid
   Styling: assets/component-upsell-compleet.css

   Twee dingen:
     1. Toevoegen via de Cart API, zonder de winkelwagen te openen. Een upsell
        is een bijzaak; de lade eroverheen gooien haalt de bezoeker uit de
        productpagina waar hij nog bezig is.
     2. De vergrote foto. Op desktop doet CSS dat met :hover; alleen waar geen
        hover bestaat neemt dit script het over met een tik.
   ========================================================================== */

(function () {
  'use strict';

  var root = document.querySelector('[data-ucp]');
  if (!root) return;

  var errorEl = root.querySelector('[data-ucp-error]');
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function showError(message) {
    if (!errorEl) return;
    errorEl.textContent = message || '';
    errorEl.hidden = !message;
  }

  /* ── Welke variant is de hoofdplant ──
     Het formulier draagt de actueel gekozen variant; de bezoeker kan die via
     de maat- of variantkiezer hebben omgezet nadat de pagina geladen was. Pas
     als dat veld er niet is vallen we terug op de waarde uit Liquid. */
  function mainVariantId() {
    var field = document.querySelector('[data-product-form] [data-variant-id]');
    if (field && field.value) return field.value;
    return root.getAttribute('data-main-variant');
  }

  function mainVariantName() {
    return root.getAttribute('data-main-title') || '';
  }

  /* ── Toevoegen ── */

  function addToCart(button) {
    if (button.disabled) return;

    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;

    var label = button.querySelector('[data-ucp-add-label]');
    var original = label ? label.textContent : '';
    var properties = {};

    /* De underscore houdt de regel uit het oog van de klant, in de winkelwagen
       en op de bon. De winkelwagen-regels in global.js lezen hem om de upsell
       te verwijderen zodra de hoofdplant eruit gaat.

       De naam staat er los bij, omdat de melding "hoort bij …" juist nodig is
       op het moment dat de hoofdplant er al uit is en zijn titel dus nergens
       meer uit de winkelwagen te halen valt. */
    properties._upsell_voor = mainVariantId();
    properties._upsell_voor_naam = mainVariantName();

    button.disabled = true;
    if (label) label.textContent = 'Bezig…';
    showError('');

    var url =
      (window.theme && window.theme.routes && window.theme.routes.cart_add_url
        ? window.theme.routes.cart_add_url
        : '/cart/add') + '.js';

    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1, properties: properties }]
      })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('cart');
        return response.json();
      })
      .then(function () {
        if (window.Verdiva && window.Verdiva.updateCartCount) {
          window.Verdiva.updateCartCount();
        }
        button.classList.add('is-added');
        if (label) label.textContent = 'Toegevoegd ✓';

        setTimeout(function () {
          button.classList.remove('is-added');
          if (label) label.textContent = original;
          button.disabled = false;
        }, 2000);
      })
      .catch(function () {
        showError('Toevoegen is niet gelukt. Probeer het nog een keer.');
        if (label) label.textContent = original;
        button.disabled = false;
      });
  }

  /* ── Plaatsing van de vergrote foto ──
     Standaard klapt hij omhoog, want daar staat meestal ruimte. Zit de rij
     te dicht onder de sticky header, dan zou de bovenkant eronder verdwijnen
     -- op mobiel gebeurde dat echt. In dat geval klapt hij omlaag. */

  function headerBottom() {
    var header = document.querySelector('[data-header]');
    if (!header) return 0;
    var rect = header.getBoundingClientRect();
    return rect.bottom > 0 ? rect.bottom : 0;
  }

  function positionPreview(thumb) {
    var item = thumb.closest('[data-ucp-item]');
    var preview = item && item.querySelector('[data-ucp-preview]');
    if (!item || !preview) return;

    var ruimteBoven = thumb.getBoundingClientRect().top - headerBottom() - 10;
    item.classList.toggle('is-preview-below', ruimteBoven < preview.offsetHeight);
  }

  /* ── Vergrote foto op apparaten zonder hover ── */

  function closeAllPreviews() {
    root.querySelectorAll('[data-ucp-item].is-preview-open').forEach(function (item) {
      item.classList.remove('is-preview-open');
      var thumb = item.querySelector('[data-ucp-thumb]');
      if (thumb) thumb.setAttribute('aria-expanded', 'false');
    });
  }

  function togglePreview(thumb) {
    var item = thumb.closest('[data-ucp-item]');
    if (!item) return;

    var isOpen = item.classList.contains('is-preview-open');
    closeAllPreviews();

    if (!isOpen) {
      positionPreview(thumb);
      item.classList.add('is-preview-open');
      thumb.setAttribute('aria-expanded', 'true');
    }
  }

  /* Op desktop doet CSS het openklappen, maar de keuze boven of onder moet
     wél bepaald zijn vóór de muis er is. */
  root.addEventListener(
    'mouseover',
    function (e) {
      if (!canHover) return;
      var thumb = e.target.closest('[data-ucp-thumb]');
      if (thumb) positionPreview(thumb);
    },
    true
  );

  root.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-ucp-add]');
    if (addBtn) {
      addToCart(addBtn);
      return;
    }

    var thumb = e.target.closest('[data-ucp-thumb]');
    if (thumb && !canHover) {
      togglePreview(thumb);
    }
  });

  /* Ernaast tikken sluit hem weer. */
  document.addEventListener('click', function (e) {
    if (canHover) return;
    if (e.target.closest('[data-ucp-thumb]')) return;
    closeAllPreviews();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllPreviews();
  });
})();
